import * as PaymentConstants from "../constants/payment.constant";
import { Loading } from "../utils/helpers/constants";

const initialState = {
  partnerDetails: {},
  partnerLink: "",
  paymentLoading: "",
  currencies: [],
  currencyLoading: "",
};

const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case PaymentConstants.MAKE_PAYMENT_REQUEST:
      return { ...state, paymentLoading: Loading.FETCHING };

    case PaymentConstants.MAKE_PAYMENT_SUCCESS:
      return {
        ...state,
        partnerDetails: action.payload,
        partnerLink: action.payload.data.partnerLink,
        paymentLoading: Loading.SUCCESS,
      };

    case PaymentConstants.MAKE_PAYMENT_FAILURE:
      return { ...state, paymentLoading: Loading.ERROR };

    case PaymentConstants.GET_CURRENCY_REQUEST:
      return { ...state, currencyLoading: Loading.FETCHING };

    case PaymentConstants.GET_CURRENCY_SUCCESS:
      return {
        ...state,
        currencies: action.payload,
        currencyLoading: Loading.SUCCESS,
      };

    case PaymentConstants.GET_CURRENCY_FAILURE:
      return { ...state, currencyLoading: Loading.ERROR };

    case PaymentConstants.VERIFY_PAYMENT_REQUEST:
      return { ...state, paymentLoading: Loading.FETCHING };

    case PaymentConstants.VERIFY_PAYMENT_SUCCESS:
      return {
        ...state,
        paymentLoading: Loading.SUCCESS,
      };

    case PaymentConstants.VERIFY_PAYMENT_FAILURE:
      return { ...state, paymentLoading: Loading.ERROR };

    default:
      return state;
  }
};

export default paymentReducer;
